import { OlCommission } from '../../../lib/types/models/ol/commission/ol-commission'
import { OlCommissionInput } from '../../../lib/types/models/ol/commission/ol-commission-input'
import { IdInput } from '../../../lib/types/utils'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const duplicateOlCommission = async (data: IdInput<OlCommissionInput>) => {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.ols.duplicateOlCommission.url, { id }))
    .post<OlCommission, OlCommissionInput>(rest)
}
